import {Injectable} from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';
import bg from './countries/bg.json';
import da from './countries/da.json';
import de from './countries/de.json';
import en from './countries/en.json';
import es from './countries/es.json';
import fi from './countries/fi.json';
import fr from './countries/fr.json';
import hu from './countries/hu.json';
import it from './countries/it.json';
import no from './countries/no.json';
import sv from './countries/sv.json';

@Injectable()
export class CountryListService {

  constructor() {
    i18nIsoCountries.registerLocale(bg);
    i18nIsoCountries.registerLocale(da);
    i18nIsoCountries.registerLocale(de);
    i18nIsoCountries.registerLocale(en);
    i18nIsoCountries.registerLocale(es);
    i18nIsoCountries.registerLocale(fi);
    i18nIsoCountries.registerLocale(fr);
    i18nIsoCountries.registerLocale(hu);
    i18nIsoCountries.registerLocale(it);
    i18nIsoCountries.registerLocale(no);
    i18nIsoCountries.registerLocale(sv);
  }

  getAllCountries(lang: string) {
    return i18nIsoCountries.getNames(lang);
  }
}
